/**
 * Whether a value is a record id, the only thing that may go in a record URL.
 *
 * A route that lost its id hands a screen `undefined`, and `String(id)` turns
 * that into the word "undefined", which was sent as
 * `/v1/records/undefined/schema` and came back as "recordId must be a record
 * uuid. (HTTP 400)". The server takes a uuid and nothing else
 * (`routes/records.ts`), and every record id the phone holds is one, the
 * device-made ones too (`lib/local-id.ts`), so this asks the same question.
 */
const RECORD_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isRecordId = (value: unknown): value is string => typeof value === 'string' && RECORD_ID.test(value);
